import { StaffListPage } from '../staff/StaffListPage';

const Admins = () => (
	<StaffListPage
		title="Administradores"
		description="Contas com acesso total ao painel administrativo."
		staffType="ADMIN"
	/>
);

export { Admins };
